declare namespace $ {

	export class $mol_icon_restore extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=restore.view.tree.d.ts.map